// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/index'
import ElementUI from 'element-ui'
import VueRouter from 'vue-router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import axios from 'axios'

import $ from 'jquery'
window.jQuery = $
// require('./assets/js/scripts.js')

//轮播图
import 'swiper/dist/css/swiper.css'
import './assets/styles/style.css'
import './assets/styles/slick.css'
import './assets/styles/slick-theme.css'
import 'font-awesome/css/font-awesome.css'
// import 'bootstrap/dist/js/bootstrap.js'
import 'bootstrap/dist/css/bootstrap.css'

import vHeader from './components/v-header.vue'
import vFooter from './components/v-footer.vue'
import vLoading from './components/v-loading.vue'

Vue.config.productionTip = false

//全局注册，this.$axios
Vue.prototype.$axios = axios    
Vue.prototype.baseURL = process.env.API_ROOT
Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(VueAwesomeSwiper)
Vue.component("v-header",vHeader)
Vue.component("v-footer",vFooter)
Vue.component("v-loading",vLoading)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js